import React from 'react';
import { RichText, Elements } from 'prismic-reactjs';
import { Link, makeStyles } from '@material-ui/core';

const htmlSerializer = (type, element, content, children, key) => {
  switch (type) {
    // Add a class to paragraph elements
    case Elements.paragraph:
      return content;

    case Elements.hyperlink:
      return (
        <Link key={key} href={element.data.url}>
          {content}
        </Link>
      );

    default:
      return null;
  }
};

const useStyles = makeStyles(() => ({
  root: {
    '& p': {
      margin: 'unset',
    },
  },
}));

export default function ({ render }) {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <RichText render={render} htmlSerializer={htmlSerializer} />
    </div>
  );
}
